import { z } from 'zod';

// Validators are curried: call with optional message (or params) to get (value) => string
export const formValidators = {
  required:
    (message: string) =>
    (value: unknown): string => {
      const v = value ?? '';
      return !String(v).trim() ? message : '';
    },
  alpha:
    (message: string) =>
    (value: unknown): string => {
      const v = value ?? '';
      return /^[A-Za-zÀ-Ÿà-ÿ\s'-]+$/.test(String(v)) ? '' : message;
    },
  alphanumeric:
    (message: string) =>
    (value: unknown): string => {
      const v = value ?? '';
      return /^[A-Za-z0-9]+$/.test(String(v)) ? '' : message;
    },
  numeric:
    (message: string) =>
    (value: unknown): string => {
      const v = value ?? '';
      return /^[0-9]+(\.[0-9]{1,2})?$/.test(String(v)) ? '' : message;
    },
  email:
    (message: string) =>
    (value: unknown): string => {
      const v = value ?? '';
      return z.email().safeParse(String(v)).success ? '' : message;
    },
  phone:
    (message: string) =>
    (value: unknown): string => {
      const raw = String(value ?? '');
      if (!/^\+?[0-9\s().-]+$/.test(raw)) {
        return message;
      }
      const digits = raw.replace(/\D/g, '');
      return digits.length >= 4 && digits.length <= 14 ? '' : message;
    },
  minLength:
    (min: number, message: string) =>
    (value: unknown): string => {
      const v = String(value ?? '');
      return v.length >= min ? '' : message;
    },
  maxLength:
    (max: number, message: string) =>
    (value: unknown): string => {
      const v = String(value ?? '');
      return v.length <= max ? '' : message;
    },
  maxNumber:
    (max: number, message: string) =>
    (value: unknown): string => {
      const v = Number(value);
      return !isNaN(v) && v <= max ? '' : message;
    },
  minNumber:
    (min: number, message: string) =>
    (value: unknown): string => {
      const v = Number(value);
      return !isNaN(v) && v >= min ? '' : message;
    },
  noDigits:
    (message: string) =>
    (value: unknown): string => {
      const v = String(value);
      return /\d/.test(v) ? message : '';
    },
  usZipCode:
    (message: string) =>
    (value: unknown): string => {
      const v = String(value);
      return /^\d{5}(-\d{4})?$/.test(v) ? '' : message;
    },
};
